import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

type StyledHeaderSubNavActionsProps = {
  $isAlignedLeft?: boolean;
  $isAlignedRight?: boolean;
};

function isAlignedRightStyle({ $isAlignedRight = false }: StyledHeaderSubNavActionsProps) {
  if ($isAlignedRight) {
    return css`
      justify-content: flex-end;

      > div {
        margin-left: 40px;
      }
    `;
  }
}

function isAlignedLeftStyle({ $isAlignedLeft = false }: StyledHeaderSubNavActionsProps) {
  if ($isAlignedLeft) {
    return css`
      float: left;
      justify-content: start;

      > div {
        margin-right: 40px;
      }
    `;
  }
}

export default styled.div<StyledHeaderSubNavActionsProps>`
  display: flex;
  justify-content: flex-end;

  > div {
    display: flex;
    align-items: center;
  }

  span {
    font-size: 1rem;
    margin-right: 0;
    padding-top: 0;
    color: ${Colours.white};
  }

  span::after {
    border-bottom: 1px solid ${Colours.lime};
  }

  ${isAlignedRightStyle}
  ${isAlignedLeftStyle}
`;
